import React from 'react';
import { offerPricing, offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offerta" className="w-full bg-surface px-5 py-20 sm:py-28" data-id="element-173" data-mp="17y3505b7no2g">
      <div className="mx-auto max-w-md" data-id="element-174" data-mp="1mmh8miggbgk2">
        <div className="text-center" data-id="element-175" data-mp="1mplmk7jpxqnx">
          <span className="text-[11px] font-bold uppercase tracking-[0.22em] text-success" data-id="element-176" data-mp="1hnw96l90x0wo">
            Paiement unique
          </span>
          <h2 className="mt-4 font-display text-[1.75rem] font-black leading-tight tracking-tight text-foreground sm:text-[2.4rem]" data-id="element-177" data-mp="tzd7wpoe5oe3">
            Offre de Lancement{' '}
            <span className="italic text-emphasis" data-id="element-178" data-mp="13xavdayffh5n">Imbattable</span>
          </h2>
        </div>

        <div className="relative mt-12 rounded-3xl border-2 border-primary bg-surface px-7 pb-8 pt-11 shadow-card" data-id="element-179" data-mp="yxoij2mig2xd">
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-primary px-4 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-primary-foreground" data-id="element-180" data-mp="2fav5uvzpu8uk">
            Pack Musique Prête™
          </span>

          <dl data-id="element-181" data-mp="ujbms5p1g6wm">
            {offerRows.map(row => <div key={row.label} className="flex items-center justify-between gap-4 border-b border-foreground/10 py-4 text-sm" data-id="element-182" data-mp="uhqukmq7501x">
                <dt className="text-foreground/75" data-id="element-183" data-mp="13iysh3osvyvh">{row.label}</dt>
                <dd className="font-bold text-foreground" data-id="element-184" data-mp="6tzgpep0ceyj">{row.value}</dd>
              </div>)}
            <div className="flex items-center justify-between gap-4 border-b border-foreground/10 py-4 text-sm" data-id="element-185" data-mp="bsarbrn4mtht">
              <dt className="font-bold uppercase tracking-wide text-foreground" data-id="element-186" data-mp="fu5p4m5umoqu">
                Valeur totale&nbsp;:
              </dt>
              <dd className="font-bold text-foreground/40 line-through" data-id="element-187" data-mp="kmfcbufkxapf">
                {offerPricing.totalValue}
              </dd>
            </div>
          </dl>

          <p className="mt-6 text-center text-[11px] font-extrabold uppercase tracking-[0.18em] text-success" data-id="element-188" data-mp="3o95xbvlkp2nn">
            Aujourd&apos;hui pour seulement
          </p>
          <div className="border-b border-foreground/10 pb-7 pt-2 text-center" data-id="element-189" data-mp="qgxi0582zdpx">
            <p className="text-base font-medium leading-none text-foreground/30 line-through sm:text-lg" data-id="element-190" data-mp="qetfnrptymrr">
              {offerPricing.totalValue}
            </p>
            <p className="mt-2 font-display text-6xl font-black leading-none text-primary" data-id="element-191" data-mp="107s3369lc79s">
              {offerPricing.price}
            </p>
          </div>

          <CtaButton label="Téléchargez tout le pack" className="mt-7 w-full" data-id="element-192" data-mp="7i1pqzfs99eq" />

          <p className="mt-4 text-center text-[11px] font-medium text-foreground/50" data-id="element-193" data-mp="7k4p4a2tsew4">
            Paiement unique · Accès illimité · Téléchargement instantané
          </p>
        </div>
      </div>
    </section>;
}